export const paramName = {
  questionIndexStr: 'questionIndexStr',
  answerIdStr: 'answerIdStr',
  surveyQestionPageIndexStr: 'pageIndexStr',
} as const;

export const appPath = {
  shopqr: {
    couponIntro: `/coupon_intro`,
    inputAnswer: `/input/:${paramName.surveyQestionPageIndexStr}`,
    sentAnswer: `/sent`,
    registerEmail: `/register_email`,
    coupon: `/coupon`,
    inputAnswerPreview: `/input_preview/:${paramName.surveyQestionPageIndexStr}`,
    couponPreview: `/coupon_preview`,
    inputBranch: `/input_branch`,
  },
  coupon: {
    show: `/coupon/show`,
    readQr: `/read_qr`,
  },
}

export const routerBaseName = '/cx/user';
